export default "__VITE_ASSET__Czjx1zk3__"